import { Button, Form, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { UniversityFormComponent } from './UniversityFormComponent';
import type { University, UniversityPostDto } from '../../Types/interfaces';
import { PostUniversity } from '../../helper/apiHelper';

// The administrator creates the university with its rectors, legal department and work place safety members.
// The departments, study lines and sessions are set up by the rector for each study year.
export const CreateUniversityComponent = (): ReactNode => {
  const [messageApi, messageContextHolder] = message.useMessage();
  const { t } = useTranslation();
  const [form] = useForm();

  const handleSubmit = async (
    values: Pick<University, 'university'>
  ): Promise<void> => {
    const university: UniversityPostDto = {
      name: values.university.name,
      rectorsEmails: values.university.rectors || [],
      workPlaceSafetySupervisorsEmails:
        values.university.workplaceSafetySupervisors || [],
      legalDepartmentMembersEmails:
        values.university.legalDepartmentMembers || [],
    };

    try {
      await PostUniversity(university);
      messageApi.success(t('uniForm.regSuccess'));
      form.resetFields();
    } catch {
      messageApi.error(t('uniForm.regFailure'));
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit}>
      {messageContextHolder}
      <UniversityFormComponent />

      <Button
        style={{ marginTop: '1%', width: '100%' }}
        type="primary"
        htmlType="submit"
      >
        {t('uniForm.register')}
      </Button>
    </Form>
  );
};
